<template>
  <h2 styleName="opt_header">
    {{roomDetail.data.lessonName}}
  </h2>
</template>
<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import { mapGetters } from 'vuex'
export default {
  mixins: [CSSModules(styles)],
  computed: {
    ...mapGetters(['roomDetail'])
  }
}
</script>
